import React, { useState } from "react";

//
import NumberFormat from "react-number-format";
import { Button, Card, Row, Col, Form, Modal } from "react-bootstrap";

//
import DateSelect from "../general/DateSelect";
import originalMoment from "moment";
import { extendMoment } from "moment-range";

//
import FilterDropdown from "../general/FilterDropdown";

import {
  repeats,
  accumullates,
  startings,
  compares,
} from "../../constances.js";
import { useEffect } from "react";

import { getCoindestBTCHistory } from "../../redux/features/coins/actions";
import calculateInterval from "../../hooks/calculateInterval";
import calculateGraphArray from "../../hooks/calculateGraphArray";
import calculateTotals from "../../hooks/calculateTotals";

const moment = extendMoment(originalMoment);

function FilterSettingForm({ updateChartData }) {
  const [show, setShow] = useState(false);

  const [summery, setSummery] = useState({
    costBasis: 0,
    gain: 0,
    percentageGain: 0,
    totalPrincipal: 0,
  });

  const [invest, setInvest] = useState(100);
  const [repeat, setRepeat] = useState({
    name: "Monthly",
    value: "monthly",
  });
  const [compare, setCompare] = useState({});
  const [starting, setStarting] = useState(moment(new Date("2017-01-01")));
  const [ending, setEnding] = useState(moment());
  const [accumullate, setAccumullate] = useState({});

  useEffect(() => {
    if (invest && repeat.value && starting) {
      let content = {
        start: starting.format("YYYY-MM-DD"),
        end: ending.format("YYYY-MM-DD"),
      };
      getCoindestBTCHistory(content).then((res) => {
        if (res) {
          // breaks the results into an array of arrays [['2019-11-02', 89.20], ['2010-11-03', 89.30]...]
          let dailyLogs = Object.entries(res.bpi);

          // reduces the array based on the time period the user entered
          let logs = calculateInterval(dailyLogs, repeat.value);

          // shapes the data into an object {date:['2018-11-01'..], price:[22...], shares:[1, 2, 3...]}
          let graphArray = calculateGraphArray(logs, invest);

          // updateData({date:dataObj.date, price:dataObj.price, shares:dataObj.shares, investment:dataObj.investment, principal:dataObj.principal});

          let newData = calculateTotals(graphArray);

          setSummery({
            costBasis: newData.costBasis,
            gain: newData.gain,
            percentageGain: newData.percentageGain,
            totalPrincipal: newData.totalPrincipal,
          });

          updateChartData(graphArray);
        }
      });
    }
  }, [invest, repeat, starting]);

  return (
    <Card className="setting h-100">
      <Card.Header className="text-black">
        <Row>
          <Col md={8} lg={12}>
            DCA Setting
          </Col>
          <Col md={4} className="d-lg-none">
            <Button
              variant="info"
              size="lg"
              className="open-modal-btn"
              onClick={() => setShow(true)}
            >
              Create Simulation
            </Button>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="d-none d-lg-block">
        {/* Purchase Amount: */}
        <Form.Group className="form-group sm">
          <Form.Label>Purchase Amount:</Form.Label>
          <div className="input-holder left">
            <NumberFormat
              value={invest}
              className="form-control fw-bolder"
              thousandSeparator={true}
              onValueChange={(values) => {
                const { value } = values;
                setInvest(value);
              }}
            />
            <span>$</span>
          </div>
        </Form.Group>

        {/* Repeat Purchase */}
        <Form.Group className="form-group sm">
          <Form.Label>Repeat Purchase</Form.Label>
          <FilterDropdown
            filters={repeats}
            activeFilter={repeat}
            action={(item) => setRepeat(item)}
            full
            fit
          />
        </Form.Group>

        {/* Accumullate For */}
        {/* <Form.Group className="form-group sm">
          <Form.Label>Accumullate For</Form.Label>
          <FilterDropdown
            filters={accumullates}
            activeFilter={accumullate}
            action={(item) => setAccumullate(item)}
            full
            fit
          />
        </Form.Group> */}

        {/* Staring */}
        <Form.Group className="form-group sm">
          <Form.Label>Staring</Form.Label>
          {/* <FilterDropdown
            filters={startings}
            activeFilter={starting}
            action={(item) => setStarting(item)}
            full
            fit
          /> */}
          <DateSelect
            activeFilter={starting}
            action={(item) => setStarting(item)}
            icon="las la-calendar-minus"
            fit
            full
          />
        </Form.Group>

        {/* Compare */}
        {/* <Form.Group className="form-group sm">
          <Form.Label>Compare to other assets ?</Form.Label>
          <FilterDropdown
            filters={compares}
            activeFilter={compare}
            action={(item) => setCompare(item)}
            full
            fit
          />
        </Form.Group> */}
      </Card.Body>

      <Modal
        id="dca-modal"
        centered
        size="lg"
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <h5>DCA Setting</h5>
        </Modal.Header>
        <Modal.Body>
          {/* Purchase Amount: */}
          <Form.Group className="form-group sm">
            <Form.Label>Purchase Amount:</Form.Label>
            <div className="input-holder left">
              <NumberFormat
                value={invest}
                className="form-control fw-bolder"
                thousandSeparator={true}
                onValueChange={(values) => {
                  const { value } = values;
                  setInvest(value);
                }}
              />
              <span>$</span>
            </div>
          </Form.Group>

          {/* Repeat Purchase */}
          <Form.Group className="form-group sm">
            <Form.Label>Repeat Purchase</Form.Label>
            <FilterDropdown
              filters={repeats}
              activeFilter={repeat}
              action={(item) => setRepeat(item)}
              full
              fit
            />
          </Form.Group>

          {/* Accumullate For */}
          {/* <Form.Group className="form-group sm">
            <Form.Label>Accumullate For</Form.Label>
            <FilterDropdown
              filters={accumullates}
              activeFilter={accumullate}
              action={(item) => setAccumullate(item)}
              full
              fit
            />
          </Form.Group> */}

          {/* Staring */}
          <Form.Group className="form-group sm">
            <Form.Label>Staring</Form.Label>
            <DateSelect
              activeFilter={starting}
              action={(item) => setStarting(item)}
              icon="las la-calendar-minus"
              fit
              full
            />
          </Form.Group>

          {/* Compare */}
          {/* <Form.Group className="form-group sm">
            <Form.Label>Compare to other assets ?</Form.Label>
            <FilterDropdown
              filters={compares}
              activeFilter={compare}
              action={(item) => setCompare(item)}
              full
              fit
            />
          </Form.Group> */}
        </Modal.Body>
      </Modal>
    </Card>
  );
}

export default FilterSettingForm;
